export const FETCH_FILES_DATA_REQUEST = "FETCH_FILES_DATA_REQUEST";
export const FETCH_FILES_DATA_SUCCESS = "FETCH_FILES_DATA_SUCCESS";
export const FETCH_FILES_DATA_FAILURE = "FETCH_FILES_DATA_FAILURE";
